/**
 * cart-drawer.js — Rigotti Arrotino
 * Scritto in ES5 puro per compatibilità con il minificatore Shopify CDN
 */
 
(function () {
  'use strict';
 
  var FREE_SHIPPING_THRESHOLD = 9999;
  var SHIPPING_COST = 700;
  var FBT_SHOP = 'kgrindr.myshopify.com';
 
  var drawer      = document.getElementById('cart-drawer');
  var closeBtn    = document.getElementById('cart-drawer-close');
  var continueBtn = document.getElementById('cart-drawer-continue');
  var itemsEl     = document.getElementById('cart-drawer-items');
  var shippingEl  = document.getElementById('cart-drawer-shipping');
  var upsellWrap  = document.getElementById('cart-drawer-upsell');
  var upsellScroll= document.getElementById('cart-drawer-upsell-scroll');
 
  if (!drawer) return;
 
  // ─── Overlay creato via JS ─────────────────────────────────
  var overlay = document.createElement('div');
  overlay.id = 'cart-drawer-overlay';
  overlay.setAttribute('aria-hidden', 'true');
  var overlayInner = document.createElement('span');
  overlayInner.setAttribute('aria-hidden', 'true');
  overlayInner.style.cssText = 'display:block;width:100%;height:100%;';
  overlay.appendChild(overlayInner);
  overlay.style.cssText = [
    'position: fixed',
    'inset: 0',
    'background: rgba(0,0,0,0.72)',
    'z-index: 10000',
    'opacity: 0',
    'visibility: hidden',
    'transition: opacity 0.3s ease, visibility 0.3s ease',
    'cursor: default',
    'pointer-events: none'
  ].join(' !important;') + ' !important;';
  document.body.appendChild(overlay);
 
  // ─── Scroll lock senza overflow:hidden ────────────────────
  var _scrollY = 0;
 
  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('active');
    overlay.style.setProperty('opacity', '1', 'important');
    overlay.style.setProperty('visibility', 'visible', 'important');
    overlay.style.setProperty('pointer-events', 'auto', 'important');
    _scrollY = window.scrollY;
    document.body.style.setProperty('position', 'fixed', 'important');
    document.body.style.setProperty('top', '-' + _scrollY + 'px', 'important');
    document.body.style.setProperty('left', '0', 'important');
    document.body.style.setProperty('right', '0', 'important');
    closeBtn.focus();
  }
 
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('active');
    overlay.style.setProperty('opacity', '0', 'important');
    overlay.style.setProperty('visibility', 'hidden', 'important');
    overlay.style.setProperty('pointer-events', 'none', 'important');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('right');
    window.scrollTo(0, _scrollY);
  }
 
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('active')) closeDrawer();
  });
 
  // ─── Intercetta icona carrello header ──────────────────────
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('a[href="/cart"]');
    if (cartLink) {
      if (cartLink.closest('#cart-drawer')) return;
      e.preventDefault();
      refreshCart().then(function () {
        loadUpsellFromCart();
      });
      openDrawer();
    }
  });
 
  // ─── Formatta valuta ───────────────────────────────────────
  function formatMoney(cents) {
    return '\u20ac' + (cents / 100).toFixed(2).replace('.', ',');
  }
 
  // ─── Escape HTML ───────────────────────────────────────────
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
 
  // ─── Aggiorna barra spedizione ─────────────────────────────
  function updateShippingBar(cartTotal) {
    if (!shippingEl) return;
    var returnsHtml = '<p class="cart-drawer__returns">\uD83D\uDD04 Reso dei prodotti fino a 30 giorni dall\'acquisto</p>';
    if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
      shippingEl.innerHTML = '<p class="cart-drawer__shipping-text is-free">\u2705 Hai ottenuto la spedizione gratuita!</p>' + returnsHtml;
    } else {
      var remaining = FREE_SHIPPING_THRESHOLD - cartTotal;
      var progress  = Math.min(Math.round(cartTotal * 100 / FREE_SHIPPING_THRESHOLD), 100);
      shippingEl.innerHTML =
        '<p class="cart-drawer__shipping-text">\uD83C\uDF81 Aggiungi <strong>' + formatMoney(remaining) + '</strong> per la spedizione gratuita</p>' +
        '<div class="cart-drawer__progress-track"><div class="cart-drawer__progress-fill" style="width:' + progress + '%;"></div></div>' +
        returnsHtml;
    }
    updateOrderSummary(cartTotal);
    if (window.updateProductShippingBar) {
      setTimeout(window.updateProductShippingBar, 200);
    }
  }
 
  // ─── Aggiorna riepilogo ordine ─────────────────────────────
  function updateOrderSummary(cartTotal) {
    var shippingCostEl = document.getElementById('cart-drawer-shipping-cost');
    var totalEl        = document.getElementById('cart-drawer-total');
    var subtotalEl     = document.getElementById('cart-drawer-subtotal');
 
    if (subtotalEl) subtotalEl.textContent = formatMoney(cartTotal);
 
    if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
      if (shippingCostEl) {
        shippingCostEl.textContent = 'Gratuita';
        shippingCostEl.className = 'cart-drawer__summary-free';
      }
      if (totalEl) totalEl.textContent = formatMoney(cartTotal);
    } else {
      if (shippingCostEl) {
        shippingCostEl.textContent = '\u20ac7,00';
        shippingCostEl.className = '';
      }
      if (totalEl) totalEl.textContent = formatMoney(cartTotal + SHIPPING_COST);
    }
  }
 
  // ─── Aggiorna contatore carrello header ────────────────────
  function updateCartBubble(count) {
    var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
    for (var i = 0; i < bubbles.length; i++) {
      bubbles[i].textContent = count;
    }
    fetch('/?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newBubble = parsed.querySelector('.shopify-section');
        var oldBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
      })
      .catch(function () {});
  }
 
  // ─── Render lista prodotti ─────────────────────────────────
  function renderItems(cartData) {
    if (!itemsEl) return;
    if (!cartData.items || cartData.items.length === 0) {
      itemsEl.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
        '<p>Il tuo carrello \u00e8 vuoto.</p>' +
        '</div>';
      if (upsellWrap) upsellWrap.style.display = 'none';
      return;
    }
    var html = '';
    for (var i = 0; i < cartData.items.length; i++) {
      var item = cartData.items[i];
      var isPreorder = false;
      var preorderNote = '';
      if (item.properties) {
        var propKeys = Object.keys(item.properties);
        for (var p = 0; p < propKeys.length; p++) {
          var pk = propKeys[p].toLowerCase();
          if (pk.indexOf('pre-ord') !== -1 || pk.indexOf('preorder') !== -1) {
            isPreorder = true;
            preorderNote = item.properties[propKeys[p]] || '';
            break;
          }
        }
      }
      var deliveryHtml = isPreorder
        ? '<p class="cart-drawer__item-preorder">\uD83D\uDCE6 Pre-ordine &mdash; ' + escapeHtml(preorderNote || 'consegna alla disponibilit\u00e0') + '</p>'
        : '<p class="cart-drawer__item-delivery">\uD83D\uDE9A Consegna stimata: 2-4 giorni lavorativi</p>';
      var variantHtml = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantHtml = '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>';
      }
      var imageHtml = '';
      if (item.featured_image && item.featured_image.url) {
        imageHtml = '<div class="cart-drawer__item-image"><img src="' + item.featured_image.url + '" alt="' + escapeHtml(item.product_title) + '" width="84" height="84" loading="lazy"></div>';
      }
      html +=
        '<div class="cart-drawer__item" data-key="' + item.key + '">' +
        imageHtml +
        '<div class="cart-drawer__item-info">' +
        '<p class="cart-drawer__item-name">' + escapeHtml(item.product_title) + '</p>' +
        variantHtml +
        deliveryHtml +
        '<div class="cart-drawer__item-bottom">' +
        '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
        '<div class="cart-drawer__qty">' +
        '<button class="cart-drawer__qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Diminuisci">&#8722;</button>' +
        '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
        '<button class="cart-drawer__qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Aumenta">+</button>' +
        '</div>' +
        '<button class="cart-drawer__item-remove" data-key="' + item.key + '">Rimuovi</button>' +
        '</div>' +
        '</div>' +
        '</div>';
    }
    itemsEl.innerHTML = html;
  }
 
  // ─── Fetch carrello e re-render ────────────────────────────
  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderItems(cart);
        updateShippingBar(cart.total_price);
        updateCartBubble(cart.item_count);
        return cart;
      });
  }
 
  // ─── Carica upsell dall'ultimo item del carrello ───────────
  function loadUpsellFromCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.items && cart.items.length > 0) {
          var lastItem = cart.items[cart.items.length - 1];
          if (lastItem.product_id) loadUpsell(lastItem.product_id);
        }
      })
      .catch(function () {});
  }
 
  // ─── Aggiorna quantità ─────────────────────────────────────
  function updateQuantity(key, newQty) {
    var itemEl = document.querySelector('.cart-drawer__item[data-key="' + key + '"]');
    if (itemEl) itemEl.classList.add('is-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderItems(cart);
        updateShippingBar(cart.total_price);
        updateCartBubble(cart.item_count);
      })
      .catch(function () {
        if (itemEl) itemEl.classList.remove('is-loading');
      });
  }
 
  // ─── Click delegation (quantità + rimuovi) ────────────────
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.cart-drawer__qty-btn');
    if (qtyBtn) {
      var key    = qtyBtn.dataset.key;
      var action = qtyBtn.dataset.action;
      var qtyEl  = qtyBtn.closest('.cart-drawer__qty').querySelector('.cart-drawer__qty-value');
      var current = parseInt(qtyEl.textContent, 10);
      var newQty  = action === 'increase' ? current + 1 : Math.max(0, current - 1);
      updateQuantity(key, newQty);
      return;
    }
    var removeBtn = e.target.closest('.cart-drawer__item-remove');
    if (removeBtn) {
      updateQuantity(removeBtn.dataset.key, 0);
      return;
    }
  });
 
  // ─── Upsell: aggiunge prodotto correlato ──────────────────
  window.cartDrawerAddUpsell = function (variantId, btn) {
    btn.textContent = '\u2026';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '\u2713 Aggiunto';
        btn.classList.add('added');
        return refreshCart();
      })
      .catch(function () {
        btn.textContent = '+ Aggiungi';
        btn.disabled = false;
      });
  };
 
  // ─── Upsell: carica prodotti FBT ──────────────────────────
  function loadUpsell(productId) {
    if (!productId || !upsellWrap || !upsellScroll) return;
    fetch('https://cdn.codeblackbelt.com/public/api/v1/frequently-bought-together?productId=' + productId + '&shop=' + FBT_SHOP)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var recs = data.recommendations;
        if (!recs || recs.length === 0) return;
        var limited = recs.slice(0, 3);
        Promise.all(limited.map(function (rec) {
          return fetch('/products/' + rec.handle + '.js').then(function (r) { return r.json(); });
        })).then(function (products) {
          var html = '';
          for (var i = 0; i < products.length; i++) {
            var product = products[i];
            var variant = product.variants[0];
            var price   = formatMoney(variant.price);
            var image   = product.featured_image || '';
            var imgHtml = image
              ? '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
              : '<div style="height:100px;background:#f5f5f5;"></div>';
            html +=
              '<div class="cart-drawer__upsell-card">' +
              '<a href="/products/' + product.handle + '" tabindex="-1">' + imgHtml + '</a>' +
              '<div class="cart-drawer__upsell-card-body">' +
              '<a href="/products/' + product.handle + '" class="cart-drawer__upsell-name">' + escapeHtml(product.title) + '</a>' +
              '<span class="cart-drawer__upsell-price">' + price + '</span>' +
              '<button class="cart-drawer__upsell-btn" onclick="cartDrawerAddUpsell(' + variant.id + ', this)">+ Aggiungi</button>' +
              '</div>' +
              '</div>';
          }
          upsellScroll.innerHTML = html;
          upsellWrap.style.display = 'block';
        });
      })
      .catch(function () {});
  }
 
  // ─── Patch CartNotification per aprire drawer ─────────────
  function patchCartNotification() {
    var CartNotificationClass = customElements.get('cart-notification');
    if (!CartNotificationClass) {
      setTimeout(patchCartNotification, 100);
      return;
    }
    CartNotificationClass.prototype.renderContents = function (parsedState) {
      refreshCart().then(function () {
        loadUpsellFromCart();
      });
      openDrawer();
      try {
        if (parsedState && parsedState.sections && parsedState.sections['cart-icon-bubble']) {
          var parsed = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
          var section = parsed.querySelector('.shopify-section');
          var oldBubble = document.getElementById('cart-icon-bubble');
          if (section && oldBubble) oldBubble.innerHTML = section.innerHTML;
        }
      } catch (e) {}
    };
  }
 
  // ─── Esporta funzioni globali ──────────────────────────────
  window.openCartDrawer    = openDrawer;
  window.closeCartDrawer   = closeDrawer;
  window.refreshCartDrawer = refreshCart;
 
  // ─── Init ─────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCartNotification);
  } else {
    patchCartNotification();
  }
 
})();